import { apiRequest } from '../config/api';

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  preferredLanguage?: string;
  name?: string;
  farmId?: string;
  farmName?: string;
  active?: boolean;
}

class UserService {
  /**
   * Update user's language preference
   */
  async updateLanguagePreference(userId: string, language: string): Promise<User> {
    try {
      const response = await apiRequest(`/api/users/${userId}/language`, 'PATCH', { language });
      return response.data;
    } catch (error: any) {
      console.error('Error updating language preference:', error);
      throw error.message || 'Failed to update language preference';
    }
  }

  /**
   * Get current user profile
   */
  async getCurrentUser(): Promise<User> {
    try {
      const response = await apiRequest('/api/auth/me', 'GET');
      return response;
    } catch (error: any) {
      console.error('Error fetching current user:', error);
      throw error.message || 'Failed to fetch user';
    }
  }

  /**
   * Update user profile
   */
  async updateProfile(userId: string, data: Partial<User>): Promise<User> {
    try {
      const response = await apiRequest(`/api/users/${userId}`, 'PUT', data);
      return response.data;
    } catch (error: any) {
      console.error('Error updating profile:', error);
      throw error.message || 'Failed to update profile';
    }
  }
}

export default new UserService();

